module.exports = "/assets/data/19bf3ef34ad5fa60852ba7ae800546aa-EX38.data.json";